import {Pipe, PipeTransform} from '@angular/core';


@Pipe({
  name: 'sum'
})
export class SumPipe implements PipeTransform {

  transform(value: any[], args: string | ((v: any) => number)): number {
    if (value === null) {
      return 0;
    }
    if (typeof (args) === 'string') {
      return value.reduce((a, v) => a + v[args], 0);
    }
    return value.reduce((a, v) => a + args(v), 0);
  }


}
